import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { Stack, Typography } from "@mui/material";
import { ColorSearchAutocomplete } from "components/input/colorSearchAutocomplete/ColorSearchAutocomplete";
import type { Dispatch } from "react";
import { CountryFlagDataDisplay } from "../../dataDisplay/CountryFlagDisplay";

export interface SubstanceListFilterProps {
  value?: Array<AutocompleteData>;
  onChange?: Dispatch<Array<AutocompleteData>>;
  t: (key: string) => string;
}

export const SubstanceListFilter = ({
  value = [],
  onChange,
  t,
}: SubstanceListFilterProps) => {
  return (
    <ColorSearchAutocomplete
      label={t("filter_general_substance")}
      type="substanceList"
      value={value}
      onChange={onChange}
      formatOptionText={(option) => (
        <Stack width="100%" direction="row" justifyContent="space-between">
          <Typography>{option.name}</Typography>
          <Typography>
            <Typography
              mr={1}
              component="span"
              fontSize="var(--body-b3-12-regular-size, 12px)"
              fontStyle="italic"
              color="text.secondary"
            >
              {option.countryIso}
            </Typography>
            <CountryFlagDataDisplay size="small" isoCode={option.countryIso!} />
          </Typography>
        </Stack>
      )}
      checkbox
      limit={50}
    />
  );
};
